import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { User } from '../models/user-account';
import { ChangePassowrd } from '../models/change-passowrd';
import { ForgetPassowrd } from '../../core/models/forget-password';
import { ProfileImg } from '../models/profile-img';
import { ActiveAndDeactiveUser } from '../models/user-account';

@Injectable({
    providedIn: 'root'
})

export class UserService {

    controller = 'User';
    constructor(private base: BaseService) { }

    getUserDataById(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetUserDataById`, { id });
    }

    changePassword(obj: ChangePassowrd): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/ChangePassword`, obj)
    }

    getUserByUserNameOrEmail(userName: string): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetUserByUserNameOrEmail`, { userName });
    }

    forgetPassword(obj: ForgetPassowrd): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/ForgetPassword`, obj)
    }

    updateUserPersonalImg(obj: ProfileImg): Observable<ApiObjectData> {
        return this.base.update<ApiObjectData>(`services/app/${this.controller}/updateUserPersonalImg`, obj)
    }

    getAllUsersPaged(
        page: number,
        pageSize: number,
        search?: string
      ): Observable<ApiObjectData> {
        const params: any = {
            page,
          pageSize
        };
      
        if (search && search.trim() !== '') {
          params.search = search;
        }
      
        return this.base.getById<ApiObjectData>(
          `services/app/${this.controller}/GetAllSerchUsersPaged`,
          params
        );
      }
      

    activate(obj: ActiveAndDeactiveUser): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/Activate`, obj)
    }

    deActivate(obj: ActiveAndDeactiveUser): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/DeActivate`, obj)
    }

    delete(Id: number) {
        return this.base.deleteByUserId<ApiObjectData>(`services/app/${this.controller}/DeleteUser`, Id);
    }

    resetPassword(userId: number): Observable<ApiObjectData> {
        return this.base.reset<ApiObjectData>(`services/app/${this.controller}/ResetPassword`, userId);
    }

    Update(obj: User): Observable<ApiObjectData> {
        return this.base.updateWithPut<ApiObjectData>(`services/app/${this.controller}/UpdateUser`, obj)
    }

    updateUserLoginTime(userId: number): Observable<ApiObjectData> {
        return this.base.UpdateUserLoginTime<ApiObjectData>(`services/app/${this.controller}/UpdateUserLoginTime`, userId);
    }
}